export class Word {
  word: string;
  metadata: WordMetadata;
  isValid: boolean = true;
  isCrossed: boolean = false;

  constructor(word: string, x: number = 0, y: number = 0, isVertical: boolean = false) {
    this.word = word;
    this.metadata = new WordMetadata(x, y, isVertical);
  }
}

export class WordMetadata {
  x: number = 0;
  y: number = 0;
  isVertical: boolean = false;
  isLocked: boolean = false;

  constructor(x: number = 0, y: number = 0, isVertical: boolean = false) {
    this.x = x;
    this.y = y;
    this.isVertical = isVertical;
  }
}
